import axios from "../customize_axios";

export const getAllOrders = async (token, page = 0) => {
  try {
    const response = await axios.get(`/api/order/admin/all?page=${page}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Fetched all orders:", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching all orders:", error);
    throw error;
  }
};

export const getOrderByOrderStatusID = async (
  token,
  orderStatusID,
  page = 0
) => {
  console.log("orderStatus", orderStatusID);
  try {
    const response = await axios.get(
      `/api/order/admin/status/${orderStatusID}?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("order", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching order:", error);
    throw error; 
  }
};

export const updateOrderStatusAPI = async (token, orderID, statusID) => {
  try {
    const response = await axios.post("/api/order/admin/update",
      {
        orderID,
        statusID
      },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    console.log(response.data)
    return response;

  } catch (error) {
    console.log("Error fetching order:", error);
    throw error; 
  }
}


export const getDetailOrderByID = async (token, orderID) => {
  try {
    const response = await axios.get(
      `/api/order/${orderID}`,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    // console.log("service", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching order details:", error);
    throw error;
  }
};



export const getRefundPendingOrders = async (token, page = 0) => {
  console.log("Fetching refund pending orders, page:", page);
  try {
    const response = await axios.get(
      `/api/order/refund/pending?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Refund pending orders:", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching refund pending orders:", error);
    throw error;
  }
};



export const getRefundLink = async (token, orderID) => {
  try {
    const response = await axios.get(
      `/api/order/${orderID}/refund/link`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Refund link data:", response.data);
    return response.data; 
  } catch (error) {
    console.error("Error fetching refund link:", error);
    throw error;
  }
};


export const updateRefundStatus = async (token, orderId, refundStatus) => {
  try {
    const response = await axios.post(
      `/api/order/${orderId}/refund/update`,
      {
        orderID: orderId,      
        refunded: refundStatus, 
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,  // Token xác thực nếu có
        },
      }
    );
    console.log("Refund status updated successfully:", response.data);
    return response;
  } catch (error) {
    console.error("Error updating refund status:", error);
    throw error;  // Ném lỗi nếu có
  }
};



export const getRefundCompletedOrders = async (token, page = 0) => {
  try {
    const response = await axios.get(
      `/api/order/refund/completed?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Refund completed orders data:", response.data);
    return response.data; 
  } catch (error) {
    console.error("Error fetching refund completed orders:", error);
    throw error;
  }
};



export const cancelOrder = async (token, orderID, reasonID) => {
  try {
    const response = await axios.post(
      `/api/order/admin/cancel`,
      {
        orderID,
        reasonID
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Cancelled orders data:", response);
    return response;
  } catch (error) {
    console.error("Error fetching cancelled orders:", error);
    throw error;
  }
};
